// extracted by mini-css-extract-plugin
module.exports = {"tagline":"GeneralPageHeaderTagLine_tagline__DeJgz"};